import DefaultActionAPI from '@/apis/business/common/default-action-api.js'

export default {
  namespaced: true,

  state: {
    defaultAction: {}
  },

  getters: {},

  mutations: {
    /**
     * @description Set value cho Default Action
     * @author NTQuy
     * @param {*} state
     * @param {*} option
     */
    setDefaultAction (state, action) {
      state.defaultAction = action
    }
  },

  actions: {
    /**
     * @description Lưu thông tin môn học vừa soạn phục vụ cho việc tạo mới phiếu soạn lần sau
     * @author NTQuy
     * @param {*} context
     * @param {*} defaultAction
     * @returns
     */
    saveDefaultAction (context, defaultAction) {
      return new Promise((resolve, reject) => {
        DefaultActionAPI.postAsync('/upsert', defaultAction).then(res => {
          resolve(res.Data)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @description Lấy thông tin default action theo collection Name
     * @author NTQuy
     * @param {*} context
     * @param {*} defaultAction
     * @returns
     */
    async getDefaultAction (context, collectionName) {
      return await DefaultActionAPI.getAsync(`/${collectionName}`).then((res) => {
        context.commit('setDefaultAction', res.Data)
        return res.Data
      })
    }
  }
}
